import { locales } from '#core/i18n/lang';
import { AVAILABLE_LANGUAGES } from '#root/global.type';
import i18next, { type i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const setupI18n = async (): Promise<i18n> => {
  const i18n = i18next.createInstance();
  i18n.use(LanguageDetector);

  await i18n.init({
    fallbackLng: AVAILABLE_LANGUAGES[0],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
      convertDetectedLanguage: (lng: string) => {
        const detectedLng = lng.split('-')?.[0] || 'en';
        return AVAILABLE_LANGUAGES.find((al) => al.includes(detectedLng)) || AVAILABLE_LANGUAGES[0];
      }
    },
    resources: locales,
    interpolation: {
      escapeValue: true
    }
  });

  return i18n;
};

export { setupI18n };
